import {
  EMAIL_MAX_LENGTH,
  FREE_TEXT_MAX_LENGTH,
  NAME_MAX_LENGTH,
  ORG_MAX_LENGTH,
} from '@fyf/shared';

export interface FieldError {
  field: string;
  message: string;
}

function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validateFreeText(value: string): string | null {
  if (!value.trim()) return 'This field is required.';
  if (value.length > FREE_TEXT_MAX_LENGTH) return `Maximum ${FREE_TEXT_MAX_LENGTH} characters.`;
  return null;
}

export function validateRequired(value: string, label: string, maxLength: number): string | null {
  if (!value.trim()) return `${label} is required.`;
  if (value.length > maxLength) return `Maximum ${maxLength} characters.`;
  return null;
}

export function validateEmail(value: string): string | null {
  if (!value.trim()) return 'Email is required.';
  if (value.length > EMAIL_MAX_LENGTH) return `Maximum ${EMAIL_MAX_LENGTH} characters.`;
  if (!isValidEmail(value)) return 'Enter a valid email address.';
  return null;
}

export interface ContactFields {
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  organization: string;
}

export function validateContact(fields: ContactFields): Record<string, string> {
  const errors: Record<string, string> = {};

  const firstName = validateRequired(fields.firstName, 'First name', NAME_MAX_LENGTH);
  if (firstName) errors['firstName'] = firstName;

  const lastName = validateRequired(fields.lastName, 'Last name', NAME_MAX_LENGTH);
  if (lastName) errors['lastName'] = lastName;

  const email = validateEmail(fields.email);
  if (email) errors['email'] = email;

  const org = validateRequired(fields.organization, 'Organization', ORG_MAX_LENGTH);
  if (org) errors['organization'] = org;

  const displayName = validateRequired(fields.displayName, 'Display name', NAME_MAX_LENGTH);
  if (displayName) errors['displayName'] = displayName;

  return errors;
}
